__turbopack_context__.v({
  "author": "highlight-module-scss-module__7uhp-a__author",
  "blink": "highlight-module-scss-module__7uhp-a__blink",
  "content": "highlight-module-scss-module__7uhp-a__content",
  "h1": "highlight-module-scss-module__7uhp-a__h1",
  "hero": "highlight-module-scss-module__7uhp-a__hero",
  "heroContent": "highlight-module-scss-module__7uhp-a__heroContent",
  "heroImage": "highlight-module-scss-module__7uhp-a__heroImage",
  "heroImageContain": "highlight-module-scss-module__7uhp-a__heroImageContain",
  "heroText": "highlight-module-scss-module__7uhp-a__heroText",
  "veil": "highlight-module-scss-module__7uhp-a__veil",
});
